import { createSelector } from '@reduxjs/toolkit';
import { getRightUserUtilSelector } from '../../rights/selectors';
import { getMyWorkspaceIdSelector } from '../../stoerkID/selectors/StoerkId.selectors';

const getDeviceIdFromProps = (_: any, props: { deviceId?: string }) =>
  props.deviceId;
const getGroupIdFromProps = (_: any, props: { groupId?: string }) =>
  props.groupId;
export const deviceButtonsRightsSelector = createSelector(
  [
    getDeviceIdFromProps,
    getGroupIdFromProps,
    getRightUserUtilSelector,
    getMyWorkspaceIdSelector,
  ],
  (deviceId, groupId, rightsUserUtil, workspaceId) => {
    const showButtonReadIncidents = rightsUserUtil.hasRightsToReadIncident(
      deviceId,
      groupId,
      workspaceId
    );
    const showDeviceInfo = rightsUserUtil.isSupportUser();
    const showDeviceEditIcon = rightsUserUtil.hasRightsToUpdateDevice(
      deviceId,
      groupId,
      workspaceId
    );

    return {
      showDeviceInfo,
      showDeviceEditIcon,
      showButtonReadIncidents,
    };
  }
);
